import noop from 'lodash/noop'
import { Cookies } from 'react-cookie'

let cookieInstance: Cookies

// This handler is really just to avoid having to instantiate the library each time. Which doesn't
// really make sense until we start spinning up a SPA, but hey, at least then we'll be prepared, right?
const getCookieInstance = (): typeof cookieInstance => {
  if (!cookieInstance) {
    cookieInstance = new Cookies()
  }

  return cookieInstance
}

export const trackProductClick = (productID: string) => {
  try {
    fetch(
      'https://clark.trendhim.com/event',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          entity_id: parseInt(productID, 10),
          entity_type: 'product',
          event_type: 'product_click',
          user_id: getCookieInstance().get('th_uid'),
        }),
      },
    ).catch(noop)
  } catch {
    // Do NOTHING! We don't care.
  }
}

